import store from './store/index'

function startLoading() {
  store.commit('loadShow')
}

function endLoading() {
  store.commit('loadHide')
}


let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}



// WEBPACK FOOTER //
// ./src/loading.js